const FILE_TYPE_NAMES: Record<number, string> = {
  0: 'Gas Data',
  1: 'Event Log',
  2: 'General Config',
  3: 'Sensor Config',
  4: 'Gas Alarm',
  5: 'Cal/Bump',
};

export function getFileTypeName(fileType: number): string {
  return FILE_TYPE_NAMES[fileType] || `Type ${fileType}`;
}
